import { useMemo, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../../Contexts/UserContext';
import Cookies from 'js-cookie';
import { ACCESS_CONTROL_CONSTANTS, cookieConsts, FRONTEND_DASHBOARDS } from '../../core/constants';
const { SYSTEMS, UI_ACCESS, TYPES } = ACCESS_CONTROL_CONSTANTS;

const AccessControlRouteChecker = ({ system = SYSTEMS.FRAMERATE, children }) => {
	const { getAccessControlSet, user } = useContext(UserContext);
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (user !== undefined) {
			setIsLoading(false);
		}
	}, [user]);

	const hasAccessForFramerateDefaultDashboard = useMemo(() => {
		const frontendDashboardAccess = user?.frontendDashboardAccess || [];
		return frontendDashboardAccess.includes(FRONTEND_DASHBOARDS.FRAMERATE_DEFAULT_DASHBOARD);
	}, [user]);

	const generalRouteControlledAccessSet = useMemo(() => {
		return getAccessControlSet(system, TYPES.CLIENT_ROUTES, pathname);
	}, [getAccessControlSet, pathname, system]);

	const childrenVisible =
		hasAccessForFramerateDefaultDashboard && !generalRouteControlledAccessSet.has(UI_ACCESS.HIDE);

	// Handle redirection after loading is complete
	useEffect(() => {
		if (!isLoading) {
			// If the user has no access and the cookie is missing, navigate to login
			if (!childrenVisible && !Cookies.get(cookieConsts.userCookieKey)) {
				navigate('/login');
			}
		}
	}, [childrenVisible, isLoading, navigate]);

	if (isLoading) {
		return <>Loading...</>;
	}

	return <>{childrenVisible ? children : <>You Don't have access to this route</>}</>;
};

export default AccessControlRouteChecker;
